import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-20" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center bg-white rounded-2xl border border-gold/15 p-10 shadow-sm">
        <XCircle size={44} className="text-gray-300 mx-auto mb-5" />
        <h1 className="font-playfair text-2xl font-bold text-brown-dark mb-2">Checkout Canceled</h1>
        <p className="text-gray-500 text-sm leading-relaxed mb-8">
          No worries — your cart is saved and nothing was charged. Your shots will be here when you're ready.
        </p>
        <Link to="/shop" className="btn-gold" data-testid="cancel-back-to-shop-btn">Back to Shop</Link>
      </div>
    </div>
  );
}
